import axios from "axios";

export default axios.create({
  baseURL: "https://sntd.in/APS",
});
